
$(document).ready(function() {




});



document.addEventListener('DOMContentLoaded', () => {

    const clearOrdersFiltersButton = document.querySelector('.clear-orders-filter');
    if (clearOrdersFiltersButton) {
        clearOrdersFiltersButton.addEventListener('click', function () {
            const paramNameToKeep = this.dataset.ignoreFieldName;
            const originalUrl = window.location.href;
            if (paramNameToKeep) {
                return window.location.href = getUrlWithSingleParameter(originalUrl, paramNameToKeep);
            }
            return window.location.href = getUrlWithSingleParameter(originalUrl);
        });
    }

});

function getUrlWithSingleParameter(urlString, paramName = null) {
    let url = new URL(urlString);
    let newParams = new URLSearchParams();

    // Add only the desired parameter
    if (url.searchParams.has(paramName)) {
        newParams.set(paramName, url.searchParams.get(paramName));
    }

    // Reconstruct the URL with the new parameters
    url.search = newParams.toString();
    return url.toString();
}

function showLoading(value) {
    if (value) {
        document.getElementById("loading").style.display = "flex";
    } else {
        document.getElementById("loading").style.display = "none";
    }
}
